import { render, staticRenderFns } from "./SubmissionReportDetail.vue?vue&type=template&id=5cc52800"
import script from "./SubmissionReportDetail.vue?vue&type=script&lang=js"
export * from "./SubmissionReportDetail.vue?vue&type=script&lang=js"
import style0 from "./SubmissionReportDetail.vue?vue&type=style&index=0&id=5cc52800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports